var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66Z",
    fill: "#C7D7F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.04 35.7299L30.99 36.96L28.14 48.4799C27.48 51.1799 28.8 52.0801 31.08 50.4901L46.62 39.72C48.51 38.4 48.24 36.8699 45.99 36.2999L41.04 35.07L43.89 23.5499C44.55 20.8499 43.23 19.95 40.95 21.54L25.41 32.3101C23.52 33.6301 23.79 35.1599 26.04 35.7299Z",
    fill: "#437ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralFlash);
export default __webpack_public_path__ + "static/media/referral-flash.e719233f9f67bcc2ffaaf4ec2ebffbbb.svg";
export { ForwardRef as ReactComponent };